// extracted by mini-css-extract-plugin
export default {"collapse-panel":"collapse-panel_collapse-panel__FVMJv"};